import { createStrings } from '@utils/local';

export const transactionConditionJa = `\
1. D2D貨物の輸入に発生する関税、輸入消費税は基本リアルタイム口座、もしくは延納口座にてご対応いたします
2. D2D輸送費用は納品日前日までにご入金をお願いいたします\
`;

export const strings = createStrings({
  ja: {
    policyAgreement: '規約のご同意',
    information: '情報入力',
    complete: '完了',
    companyInfo: '会社情報',
    principalInfo: '担当者情報',
    checklist: '確認事項',
    delegationForm: '委任状',
    transactionCondition: transactionConditionJa,
    transactionInquiryPrompt:
      'お取引条件に関して、他にご希望、ご相談がある場合、D2D MEMBERSを申し込み後、D2Dのカスタマー担当よりご連絡いたします。',
    transactionConditionInquiry: '取引条件について相談したい',
    contactToChangeInformation:
      '*情報を変更する場合、左下の「...」アイコンをクリックして、D2Dカスタマーセンターへご連絡ください。',
    sharedInfo: '共有情報',
    D2DMemberSharedInfo: 'D2D MEMBERS 共有情報',
    sharedInfoPrompt:
      '他のD2D MEMBERSからの連携リクエストを承認すると、以下の情報がそのD2D MEMBERSと共有され、予約する際に使用されます。',
  },
});

export const placeholderStrings = createStrings({
  ja: {
    companyName: '例：株式会社エービーシーディーイーエフシー',
    englishName: '例：abcdefg Co.,ltd.',
    corporateNumber: '例：012345678901',
    corporateNumberTips: '*個人事業主の場合、1112223334445をご入力してください',
    zipcode: '例：0000000',
    address1: '都道府県・市区町村・番地を入力してください',
    address2: '建物名・号室を入力してください',
    phone: '半角数字で入力してください',
    fax: '例：06-0000-0000',
    startDate: '例：1990',
    legalCapital: '例：10000000',
    industry: '例：貨物運送取扱事業',
    employeeCount: '例：50',
    snsId: '例：wechat ID: yamatowx_111',
    email: 'yamamoto@abcdefg.co.jp',
    city: '都市名（英字名）',
  },
});

export const checklistStrings = createStrings({
  ja: {
    question1: '1、法令遵守体制が整っていますか？',
    question2: '2、リアルタイム口座をお持ちですか？',
    question2Prompt:
      '上記事項で『あり』を選択された場合は、以下に金融機関コード(4桁)+支店コード(3桁)+口座番号(7桁)の計14桁をそのままハイフォンなしでご入力をください',
    question2Placeholder: '例：12341231234567',
    question3: '3、延納口座をお持ちですか？',
    question3Prompt:
      '上記事項で『あり』を選択された場合は、税関より発行された8桁の担保番号を入力してください ',
    question3Placeholder: '例：12345678',
    question4: '4、海上・航空保険の付保を希望されますか？',
    question5:
      '5、会社及び役員等が過去３年間に関税に関する法令、外為法、その他国税・地方税等に関する違反はありませんか？',
    question5Placeholder: '発生年月日、概要',
    question6: '6、輸出入者符号を取得されていますか？',
    question6Prompt: '上記事項で『あり』を選択された場合は、以下にその番号をご入力してください。',
    question6Placeholder: '例：P00XXXXX0000',
    question7: '7、顧客ご本人以外の実輸出入者の方から委託されることがありますか？',
    question7Placeholder: '実輸出入者の概要',
    question8: '8、輸出貨物の場合でお尋ねします。',
    question8LegalQuestion:
      '関税法第69条の２第１項に挙げる輸出してはならない貨物及びイラン、イラク、北朝鮮等輸出貿易管理令第4の4条関係を仕向地とする貨物はありませんか?',
    question9: '9、輸入貨物の場合でお尋ねします。',
    question9LegalQuestion: '関税法第69条の11第１項に挙げる輸入してはならない貨物はありませんか?',
    question10:
      '10、非合法企業、反社会的勢力、テロの恐れのある関係者に該当しないことを表明し、かつ将来にわたっても該当しないことを確約されますか？',
    question11:
      '11、爆発物検査、開披検査・内容点検及び税関検査等第三者の貨物取扱に同意されますか？',
  },
});

export interface Step {
  name: string;
  label: string;
}

export const steps: Step[] = [
  {
    name: 'PolicyAgreement',
    label: strings.policyAgreement,
  },
  {
    name: 'Information',
    label: strings.information,
  },
  {
    name: 'Checklist',
    label: strings.checklist,
  },
  {
    name: 'DelegationForm',
    label: strings.delegationForm,
  },
  {
    name: 'Complete',
    label: strings.complete,
  },
];

export const readPolicyPromptJa = `\
D2D は、こうした利用規約はできれば読みたくないというユーザーの心理を理解しています。
しかし、ユーザーが D2D サービスを利用するうえで期待できること、および D2D がユーザーに期待することを、利用規約に明記することは重要です。\
`;

export const sampleMembershipForm1 = {
  companyName: '合同会社モノイド',
  englishName: 'Goudou Kaisha Monoid',
  corporateNumber: '1145141919810',
  zipcode: '518000',
  address: '3335 S Figueroa St',
  phone: '+1 02132215535',
  fax: '',
  startDate: '1989',
  representerLastName: '顾',
  representerFirstName: '杨阳',
  legalCapital: '114514',
  industry: '零食、抗生素',
  employeeCount: '114',
  principalLastName: '胡',
  principalFirstName: '志明',
  principalCellphone: '18810721255',
  principalLandline: '',
  principalEmail: '494450105@qq.com',
  transactionCondition:
    '1. D2D貨物の輸入に発生する関税、輸入消費税は基本リアルタイム口座、もしくは延納口座にてご対応いたします\n2. D2D輸送費用は納品日前日までにご入金をお願いいたします',
  question1: { answer: 'Y', reason: '' },
  question2: { answer: 'Y', reason: '123123123123123' },
  question3: { answer: 'Y', reason: '23123123123213' },
  question4: { answer: 'N', reason: '' },
  question5: { answer: 'Y', reason: '2021.1.1 覚せい剤\n2021.6.4 著作権の侵害物品\n' },
  question6: { answer: 'N', reason: '' },
  question7: { answer: 'N', reason: '' },
  question8: {
    territory: 'イラク',
    types: '著作権の侵害物品',
    amount: '100',
    illegal: 'Y',
    answer: 'Y',
  },
  question9: {
    territory: 'イラン',
    types: '覚せい剤',
    amount: '111111111',
    illegal: 'Y',
    answer: 'Y',
  },
  question10: { answer: 'N', reason: '' },
  question11: { answer: 'N', reason: '' },
};
